/*----------------------
       MEDIA
---------------------- */
Media = {
    init: function () {
        if (!$(".section-media--content").length) return;

        $(".section-media--content").each(function () {
            var $content = $(this);
            var $section = $content.closest(".section-media");

            Media.updateAudioBtn($section, $content);

            $section.on("click", ".audio-btn", function () {
                var video = Media.getVisibleVideo($content);

                if (!video) return;

                video.muted = !video.muted;
                if (!video.muted) video.volume = 1;

                $(this).toggleClass("is-unmuted", !video.muted);
            });
        });
    },

    getVisibleVideo: function ($content) {
        return $content.find(".media__item-wrapper:visible video").get(0);
    },

    updateAudioBtn: function ($section, $content) {
        var hasVideo = !!this.getVisibleVideo($content);

        $section.toggleClass("has-audio", hasVideo);
        $section.find(".audio-btn").toggleClass("is-unmuted", false);
    }
};

$(document).ready(function () {
    Media.init();
});
